import { Injectable, TemplateRef } from '@angular/core';
import { signal } from '@angular/core';


// libs/core/toast/src/lib/custom-toast.models.ts
import  type { ToastMessageOptions } from 'primeng/api';

export type ToastActionHandler = (message: ToastMessageOptions) => void;

export interface ToastAction {
  label: string;
  onClick: ToastActionHandler;
  icon?: string;
  severity?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'help' | 'danger' | 'contrast';
  outlined?: boolean;
  size?: 'small' | 'normal' | 'large';
}

export interface CustomToast extends ToastMessageOptions {
  // Put actions inside `data` so we stay compatible with MessageService
  // e.g. messageService.add({ ..., data: { actions: [...] } })
  data?: {
    actions?: ToastAction[];
    [key: string]: unknown;
  };
}

@Injectable({ providedIn: 'root' })
export class CoreToastService {

}
